import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const PaymentComparisonChart = ({ cmiData, fatouratiData }) => {
  if (!cmiData || !fatouratiData) return null;

  const chartOptions = {
    chart: {
      type: "column",
    },
    title: {
      text: "Payment Systems Comparison",
      style: {
        fontSize: "16px",
        fontWeight: "bold",
      },
    },
    xAxis: {
      categories: ["Total", "Completed/Paid", "Pending", "Failed"],
    },
    yAxis: {
      min: 0,
      title: {
        text: "Number of Payments",
      },
    },
    tooltip: {
      headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
      pointFormat:
        '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
        '<td style="padding:0"><b>{point.y}</b></td></tr>',
      footerFormat: "</table>",
      shared: true,
      useHTML: true,
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
      },
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        name: "CMI",
        data: [
          cmiData.total || 0,
          cmiData.completed || 0,
          cmiData.pending || 0,
          cmiData.failed || 0,
        ],
        color: "#1890ff",
      },
      {
        name: "Fatourati",
        data: [
          fatouratiData.total || 0,
          fatouratiData.paid || 0,
          fatouratiData.pending || 0,
          0, // Fatourati doesn't have failed status in the same way
        ],
        color: "#722ed1",
      },
    ],
  };

  return <HighchartsReact highcharts={Highcharts} options={chartOptions} />;
};

export default PaymentComparisonChart;
